<div class="search-wrapper" [ngClass]="{'isOpen': isOpen && results.length}">
  @if (!searchSections) {
    <div class="input-group">
      <input  type="text"
        id = "{{idInputToFous}}"
        class="form-control h-auto input_search"
        [(ngModel)]="key"
        (keyup.enter)="search()"
        [ngModelOptions]="{standalone: true}"
        placeholder="{{searchPlaceholder|translate}}"
        attr.aria-label="{{searchPlaceholder|translate}}">
      <div class="input-group-append">
        <button (click)="search()" class="btn search-btn app-btn-search" type="button" attr.aria-label="{{'Submit Search'|translate}}">
          <i class="sli-magnifier"></i>
        </button>
      </div>
    </div>
  } @else {
    <div class="autocomplete-wrapper">
      <div class="input-group">
        <input type="text"
          id = "{{idInputToFous}}"
          class="form-control h-auto"
          placeholder="{{searchPlaceholder|translate}}"
          attr.aria-label="{{searchPlaceholder|translate}}"
          [formControl]="searchSectionsCtrl"
          [(ngModel)]="key" #searchVal
          (keydown.enter)="setKey(searchVal.value); searchVal.blur()"
          (keydown.escape)="isOpen = false"
          (focus)="onFocus()">
        <div class="input-group-append d-flex">
          @if (key?.length > 0 && shareSvc.isMobileMode()) {
            <button
              (click)="isOpen = false; key = ''"
              class="btn app-btn-close-search"
              attr.aria-label="{{'Clear Search'|translate}}">
              <i class="material-icons">close</i>
            </button>
          }
          <button (click)="search()" class="btn search-btn app-btn-search" [ngClass]="{'isOpen': key?.length > 0 && shareSvc.isMobileMode()}" type="button" attr.aria-label="{{'Submit Search'|translate}}">
            <i class="sli-magnifier"></i>
          </button>
        </div>
      </div>
    <!--</mat-form-field>-->
    @if (isOpen && results.length) {
      <div class="autocomplete-results-wrapper">
        <div class="results-table-wrapper">
          <div class="results-table" [ngClass]="{'d-lg-table': results.length > 2 && splitRow}">
              <ng-template ngFor [ngForOf]="results" let-index="index">
              @if (index % 2 === 0) {
                <div class="grouped-results-group" [ngClass]="{'d-lg-table-cell': results.length > 2 && splitRow}">
                  <div class="results-group" [ngClass]="{'products-results': results[index]['type'] === 'products'}">
                    @if (results[index].type === 'ShowAllResults') {
                      <h5 translate class="show-all-results" (click)="search()">{{results[index].title}}</h5>
                    }
                    @if (results[index].type !== 'ShowAllResults') {
                      <h5 translate>{{results[index].title}}</h5>
                    }
                    <ul>
                      @for (item of results[index].items; track item) {
                        <li class="row">
                          @if (results[index]['imageDisplay'] || item['image_path']) {
                            <div class="col-auto">
                              @if (results[index]['imageDisplay']) {
                                <img product-image
                                  [product]="item"
                                  [size]="'Sma'"
                                  class="card-img-top img-responsive"
                                  >
                              }
                              <!--for custom search item image-->
                              @if (item['image_path']) {
                                <img
                                  [src]="restUrlsConf.beURL  + item['image_path']"
                                  class="card-img-top img-responsive"
                                  >
                              }
                            </div>
                          }
                          <button class="col result-item" (click)="optionSelectedFunc(results[index]['type'], item)" (focusout)="onFocusOut(item)">
                            @if (!results[index]['displayFieldPattern']) {
                              <span class="p-name">{{item[results[index]['displayField']]}}</span>
                            }
                            @if (results[index]['displayFieldPattern']) {
                              <span class="p-name" data-pattern [data]="item" [pattern]="results[index]['displayFieldPattern']"></span>
                            }
                            @if (item[results[index]['displayFieldDesc']]) {
                              <span class="p-desc">{{item[results[index]['displayFieldDesc']]}}</span>
                            }
                          </button>
                        </li>
                      }
                    </ul>
                  </div>
                  @if (results[index + 1]) {
                    <div class="results-group" [ngClass]="{'products-results': results[index + 1]['type'] === 'products'}">
                      @if (results[index + 1].type === 'ShowAllResults') {
                        <h5 translate class="show-all-results" (click)="search()">{{results[index + 1].title}}</h5>
                      }
                      @if (results[index + 1].type !== 'ShowAllResults') {
                        <h5 translate>{{results[index + 1].title}}</h5>
                      }
                      <ul>
                        @for (item of results[index + 1].items; track item) {
                          <li class="row">
                            @if (results[index + 1]['imageDisplay']) {
                              <div class="col-auto">
                                <img product-image
                                  [product]="item"
                                  [size]="'Sma'"
                                  class="card-img-top img-responsive"
                                  >
                              </div>
                            }
                            <button class="col result-item" (click)="optionSelectedFunc(results[index + 1]['type'], item)" (focusout)="onFocusOut(item)">
                              @if (!results[index + 1]['displayFieldPattern']) {
                                <span class="p-name">{{item[results[index + 1]['displayField']]}}</span>
                              }
                              @if (results[index + 1]['displayFieldPattern']) {
                                <span class="p-name" data-pattern [data]="item" [pattern]="results[index + 1]['displayFieldPattern']"></span>
                              }
                              @if (item[results[index + 1]['displayFieldDesc']]) {
                                <span class="p-desc">{{item[results[index + 1]['displayFieldDesc']]}}</span>
                              }
                            </button>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              }
              @if (results && key?.length > 0 && !shareSvc.isMobileMode()) {
                <button class="close-btn-desktop"
                  (click)="isOpen = false; key = ''"
                  attr.aria-label="{{'Clear Search'|translate}}">
                  <i class="material-icons">close</i>
                </button>
              }
              </ng-template>
          </div>
        </div>
      </div>
    }
  </div>
}


</div>
